document.addEventListener('DOMContentLoaded', function() {
  const quantityForms = document.querySelectorAll('#Quantity-Form');

  if (quantityForms.length > 0) {
    quantityForms.forEach(form => {
      const minusButton = form.querySelector('button[name="minus"]');
      const plusButton  = form.querySelector('button[name="plus"]');
      const quantityInput = form.querySelector('#Quantity');

      if (minusButton && plusButton && quantityInput) {
        minusButton.addEventListener('click', () => {
          const currentValue = parseInt(quantityInput.value, 10);
          if (currentValue > 1) quantityInput.value = currentValue - 1;
        });

        plusButton.addEventListener('click', () => {
          const currentValue = parseInt(quantityInput.value, 10);
          quantityInput.value = currentValue + 1;
        });
      }
    });
  }
});
